import { Directive, HostBinding, Input } from '@angular/core';

export type RefreshPhase = 'idle' | 'loading' | 'revealing';

@Directive({
  selector: '[appRefreshSurface]',
})
export class RefreshSurfaceDirective {
  @Input('appRefreshSurface') refreshPhase: RefreshPhase = 'idle';

  @HostBinding('attr.data-refresh-surface') readonly marker = '';

  @HostBinding('attr.data-refresh-phase')
  get phase(): RefreshPhase {
    return this.refreshPhase;
  }

  @HostBinding('attr.aria-busy')
  get busy(): boolean {
    return this.refreshPhase === 'loading';
  }
}
